import { Card, Spinner } from "react-bootstrap"
import { KeyDate } from "@models/keyDate.model"
import AcademicCalendarLink from "./AcademicCalendarLink"

interface KeyDatesListProps {
  keyDates: KeyDate[]
  isLoading?: boolean
  title?: string
  emptyMessage?: string
  className?: string
}

const KeyDatesList = ({
  keyDates,
  isLoading = false,
  title = "Key Dates",
  emptyMessage = "No key dates found",
  className = "",
}: KeyDatesListProps) => {
  const calendarUrl = keyDates.find((k) => k.academic_calendar_url)?.academic_calendar_url

  return (
    <Card className={`custom-card overflow-hidden h-100 border-0 mb-0 ${className}`.trim()}>
      <Card.Body className="p-0 d-flex h-100 flex-column">
        <div className="p-3 pb-0 d-flex align-items-center">
          <span className="fw-semibold fs-15">{title}</span>
          <AcademicCalendarLink url={calendarUrl} />
        </div>
        <div className="p-3 pt-2 flex-grow-1 overflow-auto">
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center py-3">
              <Spinner animation="border" size="sm" className="text-primary" />
            </div>
          ) : keyDates.length === 0 ? (
            <span className="text-muted fs-12">{emptyMessage}</span>
          ) : (
            <ul className="list-unstyled mb-0">
              {keyDates.map((item, index) => (
                <li
                  key={item.id}
                  className={`d-flex justify-content-between align-items-center py-3${index < keyDates.length - 1 ? " border-bottom" : ""}`}
                >
                  <span className="fs-13 text-truncate me-2">
                    {item.label || item.date_type}
                  </span>
                  <span className="fs-13 text-muted flex-shrink-0">
                    {item.date ? new Date(item.date).toLocaleDateString() : "—"}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}

export default KeyDatesList
